import React from 'react';

const DeleteIcon = ({ size, ...props }) => {
    // 如果有size属性，使用size；否则使用1em来继承字体大小
    const iconSize = size || '1em';
    
    return (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            style={{ 
                display: 'block',
                // 如果没有指定size，则使用font-size控制大小
                fontSize: size ? undefined : 'inherit'
            }}
            {...props}
        >
            <path
                d="M138.56 277.824h-46.336a46.656 46.656 0 0 1-46.72-46.528c0-25.728 20.928-46.592 46.72-46.592h232.512v-46.976A92.992 92.992 0 0 1 417.92 44.992h186.24c51.392 0 93.056 41.472 93.056 92.672v47.04h232.512a46.592 46.592 0 0 1 0 93.12H231.68v569.6c0 18.496 19.648 35.84 46.528 35.84h465.408c26.944 0 46.656-17.344 46.656-35.84v-569.6h93.056v569.6c0 72.32-63.68 128.512-139.648 128.512H278.208c-75.904 0-139.648-56.192-139.648-128.512v-569.6zM417.92 424.192a46.72 46.72 0 0 1 43.008 28.544 46.208 46.208 0 0 1 3.52 17.728v233.216a46.464 46.464 0 0 1-93.056 0V470.528c0-25.6 20.8-46.336 46.528-46.336z m186.24 0c25.664 0 46.528 20.736 46.528 46.336v233.152a46.4 46.4 0 0 1-64.32 42.88 46.464 46.464 0 0 1-28.8-42.88V470.528a46.208 46.208 0 0 1 13.632-32.832 46.72 46.72 0 0 1 32.96-13.504z"
            />
        </svg>
    );
};

export default DeleteIcon; 